@import 'vars';

// Align the label to the top left of the container to match the MUI label style
$left-label-spacing: 9px;
$top-label-spacing: -8px;

.react-select {
  &__label {
    position: relative;

    &--error {
      > label {
        color: $danger;
      }
    }

    > label {
      font-size: $font-size-extra-small-softphone;
      padding-left: $padding-xsmall;
      padding-right: $padding-xsmall;
      position: absolute;
      left: $left-label-spacing;
      top: $top-label-spacing;
      background: $white;
      z-index: 2;
      border-radius: $border-radius-small;
    }

    &:focus-within {
      > label {
        color: $primary;
      }
    }
  }
}
